"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileToImageOverride = void 0;
/**
 * @deprecated use type S3File instead of ImageOverride
 */
const fileToImageOverride = (file) => {
    var _a;
    const extension = (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return {
        name: file.name,
        key: '',
        isPdf: extension === 'pdf',
        isTiff: extension === 'tiff',
    };
};
exports.fileToImageOverride = fileToImageOverride;
//# sourceMappingURL=ImageOverride.js.map